<mydocma-stepper class="fi-import-stepper" [stepperConfig]="stepperConfig" [stepperOptions]="stepperOptions" (ready)="onReadyEvent($event)">
  <ng-template mydocmaStep="selectFile" let-step="step">
    <mydocma-mm-select-file-step mydocmaStepComponent [step]="step">
    </mydocma-mm-select-file-step>
  </ng-template>
  <ng-template mydocmaStep="validateImport" let-step="step">
    <mydocma-mm-validate-import mydocmaStepComponent [step]="step">
    </mydocma-mm-validate-import>
  </ng-template>
  <ng-template mydocmaStep="previewImport" let-step="step">
    <mydocma-mm-preview-import mydocmaStepComponent [step]="step">
    </mydocma-mm-preview-import>
  </ng-template>
</mydocma-stepper>
